import React, {Component} from 'react'
import {Form, FormGroup, Label, Row, Col, Input, Button, InputGroup, InputGroupAddon, FormText} from 'reactstrap'
import {AvForm, AvField} from 'availity-reactstrap-validation'
import {Mutation} from 'react-apollo'
import _ from "lodash"
import PropTypes from 'prop-types'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {toast} from 'react-toastify'
import moment from 'moment'

import UserAnnualLeaveInput from './UserAnnualLeaveInput'

import mutation from '../../../queries/server/mutations/update_user'
import userRoleTimesheetCheck from '../../../queries/server/mutations/user_role_timesheet_check'
import localMutation from '../../../queries/client_side/mutations/edit_user'

import AUSelectGenerator from '../../components/auto_updaters/ValidSelect'

const AUSelectOffice = AUSelectGenerator('offices', 'id description', 'id', ['description'])
const AUSelectUserRoles = AUSelectGenerator('user_roles', 'user_role_id description', 'user_role_id', ['description'])
const AUSelectUsers = AUSelectGenerator('users', 'user_id first_name last_name', 'user_id', ['first_name', 'last_name'])

const currentYear = moment().format('YYYY')

export default class UserDetailsForm extends Component {

    constructor(props) {
        super(props)

        this.state = {
            ...this.props.user,
            original_user_role_id: this.props.user.user_role_id,
            date_created: moment(this.props.user.date_created).format('YYYY-MM-DD'),
            timesheetAlertOpen: false,

            userLeaveModalOpen: false
        }

        //this.save = _.debounce(this.save, 1000)
    }

    save = (mutationFunc, localMutationFunc, update_timesheet_user_role) => {

        const {
            user_id,
            first_name,
            last_name,
            email,
            user_role_id,
            user_role_active_from,
            standard_hours_work_per_week,
            active,
            line_manager_user_id,
            office_id,
            login,
            standard_hours_leave_allowance,
            mobile,
            phone_number,
            timesheet_entry_required,
            display_in_scheduler,
            annual_leave_rollover_days,
            date_created,
            current_year_annual_leave_remaining,
        } = this.state

        mutationFunc({
            variables: {
                data: {
                    user_id,
                    first_name,
                    last_name,
                    email,
                    user_role_id,
                    user_role_active_from,
                    standard_hours_work_per_week,
                    active,
                    line_manager_user_id,
                    office_id,
                    standard_hours_leave_allowance,
                    mobile,
                    phone_number,
                    timesheet_entry_required,
                    display_in_scheduler,
                    username: login.username,
                    annual_leave_rollover_days,
                    date_created,
                    current_year_annual_leave_remaining,
                },
                update_timesheet_user_role
            }
        })
            .then(({data}) => {
                localMutationFunc({variables: {data: data.updateUser}})
                this.setState({
                    original_user_role_id: data.updateUser.user_role_id,
                    user_role_id: data.updateUser.user_role_id,
                    user_role_active_from: null
                })
                toast.success('User Details Updated', {autoClose: 2000})
            })
            .catch(e => toast.error(e.message, {autoClose: false}))
    }

    toggle = () => {
        this.setState({timesheetAlertOpen: !this.state.timesheetAlertOpen})
    }

    toggleUserLeaveModal = () => {
        this.setState({userLeaveModalOpen: !this.state.userLeaveModalOpen})
    }

    onChange = ({key, value}) => {
        const newData = {}
        newData[key] = value
        this.setState(newData)
    }


    render() {

        const {
            first_name,
            last_name,
            email,
            user_role_id,
            original_user_role_id,
            user_role_active_from,
            standard_hours_work_per_week,
            active,
            line_manager_user_id,
            office_id,
            login,
            standard_hours_leave_allowance,
            mobile,
            phone_number,
            timesheet_entry_required,
            display_in_scheduler,
            annual_leave_rollover_days,
            date_created,
            current_year_annual_leave_remaining,
            year_leave,
            year_leave_rolled,
        } = this.state

        return (

            <Mutation mutation={mutation}>
                {(updateUserDetailsFunc, {loading}) => (
                    <Mutation mutation={localMutation}>
                        {(updateLocalUserDetailsFunc) => (
                            <div>
                                <AvForm
                                    onValidSubmit={() => {
                                        const {
                                            user_id,
                                            first_name,
                                            last_name,
                                            email,
                                            user_role_id,
                                            original_user_role_id,
                                            user_role_active_from,
                                            standard_hours_work_per_week,
                                            active,
                                            line_manager_user_id,
                                            office_id,
                                            login,
                                            standard_hours_leave_allowance,
                                            mobile,
                                            phone_number,
                                            timesheet_entry_required,
                                            display_in_scheduler,
                                            date_created,
                                            current_year_annual_leave_remaining,
                                        } = this.state


                                        updateUserDetailsFunc({
                                            variables: {
                                                data: {
                                                    user_id,
                                                    first_name,
                                                    last_name,
                                                    email,
                                                    user_role_id,
                                                    user_role_active_from,
                                                    standard_hours_work_per_week,
                                                    active,
                                                    line_manager_user_id,
                                                    office_id,
                                                    standard_hours_leave_allowance: parseFloat(standard_hours_leave_allowance),
                                                    mobile,
                                                    phone_number,
                                                    timesheet_entry_required,
                                                    display_in_scheduler,
                                                    username: login.username,
                                                    annual_leave_rollover_days,
                                                    date_created,
                                                    current_year_annual_leave_remaining
                                                }
                                            }
                                        })
                                            .then(({data}) => {
                                                updateLocalUserDetailsFunc({variables: {data: data.updateUser}})
                                                toast.success('User Details Updated', {autoClose: 2000})
                                            })
                                            .catch(e => toast.error(e.message, {autoClose: false}))


                                    }}
                                >
                                    <Row form>
                                        <Col>
                                            <AvField
                                                required
                                                label="First Name*"
                                                type="text"
                                                name="first_name"
                                                id="first_name"
                                                className="form-control-sm"
                                                value={first_name}
                                                onChange={(evt) => {
                                                    const first_name = evt.target.value
                                                    /*this.setState({first_name}, this.save(updateUserDetailsFunc, {
                                                        ...this.state,
                                                        first_name
                                                    }, updateLocalUserDetailsFunc))*/

                                                    this.setState({first_name})
                                                }}
                                            />

                                        </Col>
                                        <Col>
                                            <AvField
                                                required
                                                label="Last Name*"
                                                type="text"
                                                name="last_name"
                                                id="last_name"
                                                className="form-control-sm"
                                                value={last_name}
                                                onChange={(evt) => {
                                                    const last_name = evt.target.value
                                                    /*this.setState({last_name}, this.save(updateUserDetailsFunc, {
                                                        ...this.state,
                                                        last_name
                                                    }, updateLocalUserDetailsFunc))*/

                                                    this.setState({last_name})
                                                }}
                                            />
                                        </Col>
                                        <Col>
                                            <AvField
                                                required
                                                label="Username*"
                                                type="text"
                                                name="username"
                                                id="username"
                                                className="form-control-sm"
                                                value={login.username}
                                                onChange={(evt) => {
                                                    const username = evt.target.value
                                                    /*this.setState({login: {username}}, this.save(updateUserDetailsFunc, {
                                                        ...this.state,
                                                        login: {username}
                                                    }, updateLocalUserDetailsFunc))*/

                                                    this.setState({login: {username}})
                                                }}
                                            />
                                        </Col>
                                    </Row>
                                    <Row form>
                                        <Col>
                                            <AUSelectUserRoles
                                                required
                                                disabled
                                                label="Current Role*"
                                                name="user_role_id"
                                                className="form-control-sm"
                                                value={user_role_id}
                                                onChange={(value) => {
                                                    const user_role_id = value
                                                    /*this.setState({user_role_id}, this.save(updateUserDetailsFunc, {
                                                        ...this.state,
                                                        user_role_id
                                                    }, updateLocalUserDetailsFunc))*/

                                                    this.setState({user_role_id})
                                                }}
                                            />
                                        </Col>
                                        <Col>
                                            <FormGroup>
                                                <Label for="name" className="m-0">Line Manager</Label>
                                                <AUSelectUsers
                                                    name="line_manager_user_id"
                                                    className="form-control-sm"
                                                    value={line_manager_user_id}
                                                    onChange={(value) => {
                                                        const line_manager_user_id = value
                                                        /*this.setState({line_manager_user_id}, this.save(updateUserDetailsFunc, {
                                                            ...this.state,
                                                            line_manager_user_id
                                                        }, updateLocalUserDetailsFunc))*/
                                                        this.setState({line_manager_user_id})
                                                    }}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col>
                                            <FormGroup>
                                                <Label className="m-0">Office</Label>
                                                <AUSelectOffice
                                                    name="office_id"
                                                    className="form-control-sm"
                                                    value={office_id}
                                                    onChange={(value) => {
                                                        const office_id = value
                                                        /*this.setState({office_id}, this.save(updateUserDetailsFunc, {
                                                            ...this.state,
                                                            office_id
                                                        }, updateLocalUserDetailsFunc))*/
                                                        this.setState({office_id})
                                                    }}
                                                />
                                            </FormGroup>
                                        </Col>

                                    </Row>
                                    <Row form>
                                        <Col>
                                            <FormGroup>
                                                <Label for="name" className="m-0">Email</Label>
                                                <Input
                                                    type="email"
                                                    name="email"
                                                    id="email"
                                                    className="form-control-sm"
                                                    value={email}
                                                    onChange={(evt) => {
                                                        const email = evt.target.value
                                                        /*this.setState({email}, this.save(updateUserDetailsFunc, {
                                                            ...this.state,
                                                            email
                                                        }, updateLocalUserDetailsFunc))*/
                                                        this.setState({email})
                                                    }}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col>
                                            <FormGroup>
                                                <Label className="m-0">Mobile</Label>
                                                <Input
                                                    type="text"
                                                    name="mobile"
                                                    id="mobile"
                                                    placeholder="Mobile"
                                                    className="form-control-sm"
                                                    value={mobile}
                                                    onChange={(evt) => {
                                                        const mobile = evt.target.value
                                                        /*this.setState({mobile}, this.save(updateUserDetailsFunc, {
                                                            ...this.state,
                                                            mobile
                                                        }, updateLocalUserDetailsFunc))*/
                                                        this.setState({mobile})
                                                    }}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col>
                                            <FormGroup>
                                                <Label className="m-0">Landline</Label>
                                                <Input
                                                    type="text"
                                                    name="phone_number"
                                                    id="phone_number"
                                                    placeholder="Landline"
                                                    className="form-control-sm"
                                                    value={phone_number}
                                                    onChange={(evt) => {
                                                        const phone_number = evt.target.value
                                                        /*this.setState({phone_number}, this.save(updateUserDetailsFunc, {
                                                            ...this.state,
                                                            phone_number
                                                        }, updateLocalUserDetailsFunc))*/
                                                        this.setState({phone_number})
                                                    }}
                                                />
                                            </FormGroup>
                                        </Col>

                                    </Row>
                                    <Row form>
                                        <Col>
                                            <FormGroup>
                                                <Label className="m-0">Start Date</Label>
                                                <Input
                                                    type="date"
                                                    name="start_date"
                                                    id="start_date"
                                                    className="form-control-sm"
                                                    value={date_created}
                                                    onChange={(evt) => {
                                                        const date_created = evt.target.value
                                                        this.setState({date_created})
                                                    }}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col>
                                            <AvField
                                                required
                                                label="Hours Work Per Week*"
                                                type="number"
                                                name="hours_worked"
                                                id="hours_worked"
                                                placeholder="Hours Worked per Week"
                                                className="form-control-sm"
                                                value={standard_hours_work_per_week}
                                                onChange={(evt) => {
                                                    const standard_hours_work_per_week = evt.target.value
                                                    /*this.setState({standard_hours_work_per_week}, this.save(updateUserDetailsFunc, {
                                                        ...this.state,
                                                        standard_hours_work_per_week
                                                    }, updateLocalUserDetailsFunc))*/
                                                    this.setState({standard_hours_work_per_week})
                                                }}
                                            />
                                        </Col>
                                    </Row>
                                    <Row form>
                                        <Col>
                                            <FormGroup>
                                                <Label className="m-0">Annual Entitlement Leave Per Year</Label>
                                                <Input
                                                    type="number"
                                                    name="annual_leave"
                                                    id="annual_leave"
                                                    placeholder="Annual Leave"
                                                    className="form-control-sm"
                                                    value={standard_hours_leave_allowance}
                                                    onChange={(evt) => {
                                                        const standard_hours_leave_allowance = evt.target.value
                                                        /*this.setState({standard_hours_leave_allowance}, this.save(updateUserDetailsFunc, {
                                                            ...this.state,
                                                            standard_hours_leave_allowance
                                                        }, updateLocalUserDetailsFunc))*/
                                                        this.setState({standard_hours_leave_allowance})
                                                    }}
                                                />
                                                <FormText color="muted">
                                                This should be the annual leave for the full year.
                                                </FormText>
                                            </FormGroup>
                                        </Col>
                                        <Col>
                                            <FormGroup>
                                                <Label className="m-0">Previous Year Rollover Annual Leave</Label>
                                                <Input
                                                    type="number"
                                                    name="annual_leave_roll"
                                                    id="annual_leave_roll"
                                                    className="form-control-sm"
                                                    disabled
                                                    value={this.props.user.year_leave_rolled}
                                                />
                                                <FormText color="muted">
                                                Number of days rolled over from the previous year.
                                                </FormText>
                                            </FormGroup>
                                        </Col>
                                        <Col>
                                            <FormGroup>
                                                <Label className="m-0">Annual Leave for Current Year</Label>
                                                <InputGroup size="sm">
                                                    <Input
                                                        type="number"
                                                        name="year_leave"
                                                        id="year_leave"
                                                        disabled
                                                        className="form-control-sm"
                                                        value={this.props.user.year_leave}
                                                    />
                                                    <InputGroupAddon addonType="append">
                                                        <Button color="success" onClick={(e) => {
                                                            e.preventDefault()
                                                            this.toggleUserLeaveModal()
                                                        }}>
                                                            <FontAwesomeIcon
                                                                color="#fff"
                                                                icon="plus"
                                                            />
                                                        </Button>
                                                    </InputGroupAddon>
                                                </InputGroup>
                                                
                                            </FormGroup>
                                        </Col>
                                        
                                        <Col>
                                            <FormGroup>
                                                <Label className="m-0">Leave Used</Label>
                                                <Input
                                                    type="number"
                                                    name="leave_used"
                                                    id="leave_used"
                                                    className="form-control-sm"
                                                    value={this.props.user.current_year_annual_leave_days_used}
                                                    disabled
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col>
                                            <FormGroup>
                                                <Label className="m-0">Total Annual Leave Remaining</Label>
                                                <Input
                                                    type="number"
                                                    name="annual_leave_remaining"
                                                    id="annual_leave_remaining"
                                                    className="form-control-sm"
                                                    value={this.props.user.current_year_annual_leave_remaining}
                                                    disabled
                                                />
                                            </FormGroup>
                                        </Col>

                                    </Row>

                                    <Row form>
                                        <Col>
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        checked={timesheet_entry_required}
                                                        onChange={(evt) => {
                                                            const timesheet_entry_required = evt.target.checked
                                                            /*this.setState({timesheet_entry_required}, this.save(updateUserDetailsFunc, {
                                                                ...this.state,
                                                                timesheet_entry_required
                                                            }, updateLocalUserDetailsFunc))*/
                                                            this.setState({timesheet_entry_required})
                                                        }}
                                                    />{' '}
                                                    Timesheet Entry Required
                                                </Label>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row form>
                                        <Col>
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        checked={display_in_scheduler}
                                                        onChange={(evt) => {
                                                            const display_in_scheduler = evt.target.checked
                                                            /*this.setState({display_in_scheduler}, this.save(updateUserDetailsFunc, {
                                                                ...this.state,
                                                                display_in_scheduler
                                                            }, updateLocalUserDetailsFunc))*/
                                                            this.setState({display_in_scheduler})
                                                        }}
                                                    />{' '}
                                                    In Scheduler
                                                </Label>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row form>
                                        <Col>
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        checked={active}
                                                        onChange={(evt) => {
                                                            const active = evt.target.checked
                                                            /*this.setState({active}, this.save(updateUserDetailsFunc, {
                                                                ...this.state,
                                                                active
                                                            }, updateLocalUserDetailsFunc))*/
                                                            this.setState({active})
                                                        }}
                                                    />{' '}
                                                    Active
                                                </Label>
                                            </FormGroup>
                                        </Col>

                                    </Row>

                                    <div className="d-flex justify-content-end align-content-end" style={{flex: 1}}>
                                        <Button
                                            size="sm"
                                            color="success"
                                            disabled={loading}
                                        >
                                            <FontAwesomeIcon
                                                color="#fff"
                                                icon={loading ? 'spinner' : 'save'}
                                                spin={loading}
                                            />{' '}
                                            {loading ? 'Saving...' : 'Save User'}
                                        </Button>
                                    </div>


                                </AvForm>
                                <UserAnnualLeaveInput
                                    user_id={this.props.user.user_id}
                                    isOpen={this.state.userLeaveModalOpen}
                                    toggle={this.toggleUserLeaveModal}
                                    onSave={(user) => {
                                        console.log('USER****', user)
                                        updateLocalUserDetailsFunc({variables: {data: user}})
                                        this.toggleUserLeaveModal()
                                    }}
                                />
                            </div>

                        )}

                    </Mutation>
                )}

            </Mutation>

        )
    }

}

UserDetailsForm.propTypes = {
    user: PropTypes.object.isRequired
}